module.exports = __webpack_public_path__ + "static/img/supervision.af054a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supervision.png
// module id = 5JjZ
// module chunks = 1